<tidy-auto-complete
  label="Address"
  [options]="autocompleteAddress"
  [icon]="'assets/svg/home.svg'"
  [form]="addressFormControl"
  [formControl]="addressFormControl"
  [errorMessage]="'Please enter a valid address'"
  [submitted]="submitted"
  (keyup)="updateSearch()"
  (action)="chooseItem($event)" />

<ng-template #noAddressPickedTemplate>
  @if (radioButtonAddress.length > 0 && submitted && (typedOnAddress || !didChooseAddress)) {
    <tidy-card>
      <tidy-row>
        <tidy-text
          [header]="'Please confirm your address:'" />
      </tidy-row>
      <tidy-row>
        <tidy-radio-button
          [helper]="'If you do not see your address please retype it above'"
          [items]="radioButtonAddress"
          (optionChange)="chooseItem($event); setAddressFormControl($event)" />
      </tidy-row>
    </tidy-card>
  }
</ng-template>
